<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    >
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>


<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        // 车辆种类
        vehicleClassOptions: [],
        form: [
          {
            label: '车队名称',
            value: 'tenantName',
            type: 'input',
            placeholder: '请输入车队名称',
          },
          {
            label: '车队联系人',
            value: 'linkman',
            type: 'input',
            placeholder: '请输入车队联系人',
          },
          {
            label: '车队联系电话',
            value: 'linkPhone',
            type: 'input',
            placeholder: '请输入车队联系电话',
          },
          {
            label: '车辆种类',
            value: 'vehicleClass',
            type: 'select',
            default: -1,
            placeholder: '车辆种类',
          },
          {
            label: '加入时间',
            value: 'Time',
            type: 'date',
            default: [],
            placeholder: '请选择加入时间',
            attr: {
              type: 'daterange',
            },
          },
        ],
      },
    };
  },
  methods: {
    sub (searchBoxData) {
      if (searchBoxData.Time && searchBoxData.Time.length > 0) {
        searchBoxData.startTime = searchBoxData.Time[0];
        searchBoxData.endTime = searchBoxData.Time[1];
      }
      searchBoxData.vehicleCode = this.$route.query.id;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'VEHICLE_CLASS',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    this.searchBoxData.vehicleClassOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(0),
    ];
  },
};
</script>

<style>
</style>
